import React from 'react';

import { CTA, ImageType } from 'utils/types';
import { DetailsSection } from '../../../components/PDP/DetailsSection';
import { ComparisonList } from '../ComparisonListModal';

export interface DetailsContainerProps {
  content: {
    listOfContentSections: {
      title: string;
      headline: string;
      subHeadline?: string;
      slug: string;
      description?: {
        description: string;
      };
      cta?: CTA;
      desktopImages?: Array<ImageType>;
      mobileImages?: Array<ImageType>;
      modalButtonText?: string;
      modalTitle?: string;
      embeddedVideoLink?: string;
      pdfFile?: {
        file: {
          url: string;
        };
      };
      listOfContentSections?: Array<{
        title: string;
        description: {
          description: string;
        };
        image: {
          file: {
            url: string;
          };
        };
        desktopImages?: Array<ImageType>;
        mobileImages?: Array<ImageType>;
        cta?: CTA;
        listOfContentSections?: Array<{
          title: string;
        }>;
      }>;
    }[];
    comparisonList?: ComparisonList;
    modalButtonText: string;
  };
  isV2: boolean;
}

export const DetailsContainer: React.FC<DetailsContainerProps> = ({
  content,
  isV2,
}) => {
  if (!content) return null;
  const { listOfContentSections, comparisonList, modalButtonText } = content;
  const props = listOfContentSections.map((section) => {
    let sectionTitle = section.title;
    let innerListOfContentSections = section.listOfContentSections;
    /* TODO a/b test: Hardcoded */
    if (isV2) {
      switch (sectionTitle) {
        case "What's included":
          sectionTitle = 'What to Expect';
          innerListOfContentSections = [
            // TODO a/b test: Hardcoded (use ts-ignore to override values)
            // @ts-ignore
            {
              title: 'Pre-paid shipping both ways',
            },
            // @ts-ignore
            {
              title:
                'All materials for sample collection and shipping back to the lab',
            },
            // @ts-ignore
            {
              title:
                'Detailed directions and an instructional video to guide you',
            },
            // @ts-ignore
            {
              title: 'Help along the way from our customer care team',
            },
            // @ts-ignore
            {
              title: 'Digital and printable results',
            },
            // @ts-ignore
            {
              title: 'Physician consult for qualified results',
            },
            // @ts-ignore
            {
              title: 'Group webinar with a healthcare professional',
            },
          ];
          break;
        case "What's in the box":
          sectionTitle = 'Sample Collection';
          break;
      }
    }

    return {
      title: sectionTitle,
      slug: section.slug,
      headline: section.headline,
      subheadline: section.subHeadline,
      copy: section.description?.description,
      cta: section.cta,
      desktopImages: section.desktopImages,
      mobileImages: section.mobileImages,
      modalButtonText: section.modalButtonText,
      modalTitle: section.modalTitle,
      link: section.embeddedVideoLink,
      pdfFileUrl: section.pdfFile?.file.url,
      listOfContent: innerListOfContentSections?.map((section) => ({
        title: section.title,
        description: section.description?.description,
        image: section.image?.file?.url,
        desktopImages: section.desktopImages,
        mobileImages: section.mobileImages,
        cta: section.cta,
        listOfContentSections: section.listOfContentSections,
      })),
    };
  });

  return (
    <DetailsSection
      content={props}
      isV2={isV2}
      comparisonList={comparisonList}
      modalButtonText={modalButtonText}
    />
  );
};

export default DetailsContainer;
